import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="logo-icon">AX</span>
              <span className="logo-text">AfreXpert</span>
            </div>
            <p>Connecting skilled professionals with clients who need them. Available across Africa and beyond.</p>
            <div className="footer-social">
              <a href="#fb" aria-label="Facebook" className="social-link">f</a>
              <a href="#tw" aria-label="Twitter" className="social-link">𝕏</a>
              <a href="#ig" aria-label="Instagram" className="social-link">📷</a>
              <a href="#li" aria-label="LinkedIn" className="social-link">in</a>
            </div>
          </div>
          <div className="footer-col">
            <h4>Navigation</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/how-it-works">How It Works</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Services</h4>
            <ul>
              <li><Link to="/services">Electricians</Link></li>
              <li><Link to="/services">Plumbers</Link></li>
              <li><Link to="/services">Carpenters</Link></li>
              <li><Link to="/services">Cleaners</Link></li>
              <li><Link to="/services">Tutors</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Download</h4>
            <a href="https://apps.apple.com" className="store-badge apple" target="_blank" rel="noopener noreferrer">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
              <span><small>Download on</small>App Store</span>
            </a>
            <a href="https://play.google.com" className="store-badge google" target="_blank" rel="noopener noreferrer">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M3.18 23.76c.37.21.8.22 1.19.04l13.07-7.42-2.82-2.83-11.44 10.21zm16.57-10.73L17 11.46l-2.85 2.55 2.85 2.55 2.77-1.6c.79-.46.79-1.53-.02-1.93zM3.08.27C2.7.49 2.44.89 2.44 1.4v21.2c0 .51.26.91.64 1.13l12.22-11.73L3.08.27zm10.95 10.14L3.18.27 16.32 7.7l-2.29 2.71z"/></svg>
              <span><small>Get it on</small>Google Play</span>
            </a>
            <p className="footer-contact-info">support@afrexpert.com</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} AfreXpert. All rights reserved.</p>
          <div className="footer-legal">
            <a href="#privacy">Privacy Policy</a>
            <a href="#terms">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
